module.exports = __webpack_public_path__ + "img/circle3@2x.ca015113.png";